<template>
    <!-- 积分管理 － 会员等级设置页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'grade')">
            <div class="wrap-container-in">
                <a-button v-if="getBtnByAuth('addVipLevel')" class="mb16" type="primary" @click="toAddVipLevel()">新增会员等级</a-button>
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                    <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                    <span slot="val" slot-scope="a,row">{{row.minVal}} ~ {{row.maxVal}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a v-if="getBtnByAuth('updateVipLevel')" class="text-primary" @click="toAddVipLevel(row)">编辑</a>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: "grade",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "序号",
                dataIndex: "index",
                scopedSlots: { customRender: "index" }
            },
            {
                title: "积分区间",
                dataIndex: "val",
                scopedSlots: { customRender: "val" }
            },
            {
                title: "会员等级",
                dataIndex: "grade",
            },
            {
                title: "会员名称",
                dataIndex: "name",
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }]
            return {
            options: [],
            columns,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                current: 1,
                pageSize: 20
            }
            };
        },
        computed: {},
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            getList() {
                this.$api.integral.memberList({
                    body: {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                })
            },
            toAddVipLevel(row=null) {
                this.$router.push({ name: "addVipLevel", query: row });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            '$route'(val) {
            val.name == 'grade' && this.getList();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 2px;
}
</style>
